import { Outlet, Link } from "react-router-dom";
import Header from "./header";
import MyFooter from "./footer";

const Layout = () => {
  return (
    <>
      <Header />
      {/* <nav>
        <ul>
          <li>
            <Link to="/test">Home</Link>
          </li>
          <li>
            <Link to="/test/alpnachersee">Alpnachersee</Link>
          </li>
          <li>
            <Link to="/test/urnersee">Urnersee</Link>
          </li>
          <li>
            <Link to="/test/gardasee">Gardasee</Link>
          </li>
          <li>
            <Link to="/test/sihlsee">Sihlsee</Link>
          </li>
          <li>
            <Link to="/test/murtensee">Murtensee</Link>
          </li>
          <li>
            <Link to="/test/greifensee">Greifensee</Link>
          </li>
          <li>
            <Link to="/test/weissensee">Weissensee</Link>
          </li>
          <li>
            <Link to="/test/zuerichsee">Zürichsee</Link>
          </li>
        </ul>
      </nav> */}
      <Outlet />
      <MyFooter />
    </>
  )
};

export default Layout;